<template>
  <Dialog :open="true" @close="props.onClose">
    <div class="fixed inset-0 flex items-center justify-center p-4 z-20 bg-zinc-700/90">
      <DialogPanel
        class="overflow-y-auto border border-white w-[800px] max-h-[90vh] flex flex-col bg-black"
      >
        <DialogTitle class="border-b border-white p-3 text-yellow-300">
          {{ text('ui.social_modal_title') }}
        </DialogTitle>

        <div class="w-full flex">
          <div class="w-full p-4 flex flex-col items-center">
            <!-- email signup link -->
            <div class="w-full text-center no-select">
              <EmailSignupForm />
            </div>
            <div
              v-if="Config.PLATFORM !== 'yandex'"
              class="w-full text-center flex flex-col items-center"
            >
              <!-- product roadmap message -->
              <div v-if="Config.LOCALE === 'en'">
                <hr class="w-full my-4 border border-1 border-grey" />
                <div class="px-2 w-full text-left no-select text-sm text-pink-400">
                  The
                  <a
                    href="https://workflowy.com/s/dungeon-team-product/ZdeNc5sHYhomdNYe"
                    target="_blank"
                    >Dungeon Team Roadmap</a
                  >
                  is a living document that lists all the features and improvements I'm working on.
                  You can help me by sharing your ideas and/or priority recommendations in
                  <a :href="DISCORD_URL" target="_blank" class="underline">Discord</a>.
                </div>
              </div>
              <!-- bug report message -->
              <hr class="w-full my-4 border border-1 border-grey" />
              <div class="px-2 w-full text-left no-select text-sm text-red-300">
                <span class="font-bold">{{ text('ui.bug_report_title') }}</span>
                <span class="ml-2">{{ text('ui.bug_report_cta') }}</span>
                <a :href="BUG_REPORTS_DISCORD_URL" target="_blank" class="underline ml-1">{{
                  text('ui.bug_report_link_text')
                }}</a
                >.
              </div>
              <!-- wiki message -->
              <hr class="w-full my-4 border border-1 border-grey" />
              <div class="w-full text-center no-select text-sm text-orange-400">
                {{ text('ui.wiki_message') }}:
                <a href="https://dungeon-team.fandom.com" target="_blank"
                  >https://dungeon-team.fandom.com</a
                >
              </div>
              <hr class="w-full my-4 border border-1 border-grey" />
              <!-- discord embed -->
              <iframe
                id="discord_embed"
                :src="
                  Config.LOCALE === 'ru'
                    ? 'https://discord.com/widget?id=1320537408177180783&theme=dark'
                    : 'https://discord.com/widget?id=1003381121792364604&theme=dark'
                "
                width="650"
                height="400"
                allowtransparency="true"
                frameborder="0"
                sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
              ></iframe>
            </div>
            <!-- moar shit 1st column here -->
          </div>
          <!-- <div class="grow p-4 flex flex-col items-center overflow-y-visible">
            <iframe
              id="reddit_embed"
              src="https://www.redditmedia.com/r/dungeon_team/comments/12ey1jq/intro_to_temple/?ref\\\_source=embed\\\&amp;ref=share\\\&amp;embed=true"
              sandbox="allow-scripts allow-same-origin allow-popups"
              style="border: none;"
              width="400"
              height="180"
              scrolling="yes"
              class="mt-4 rounded-md min-h-[180px]"
            ></iframe>
            <iframe
              id="reddit_embed"
              src="https://www.redditmedia.com/r/dungeon_team/comments/112bo0k/dungeon_team_hero_builds_demo/?ref\\\_source=embed\\\&amp;ref=share\\\&amp;embed=true"
              sandbox="allow-scripts allow-same-origin allow-popups"
              style="border: none;"
              width="400"
              height="370"
              scrolling="yes"
              class="mt-4 rounded-md min-h-[370px]"
            ></iframe>
            <iframe
              id="reddit_embed"
              src="https://www.redditmedia.com/r/dungeon_team/comments/113rbsu/dungeon_team_on_steam/?ref\\\_source=embed\\\&amp;ref=share\\\&amp;embed=true"
              sandbox="allow-scripts allow-same-origin allow-popups"
              style="border: none;"
              width="400"
              height="150"
              scrolling="yes"
              class="mt-4 rounded-md min-h-[150px]"
            ></iframe>
          </div> -->
        </div>
      </DialogPanel>
    </div>
  </Dialog>
</template>

<script setup>
import { reactive } from 'vue';
import { Dialog, DialogPanel, DialogTitle } from '@headlessui/vue';
import Config from '~/constants/Config';
import { BUG_REPORTS_DISCORD_URL, DISCORD_URL } from '~/constants';
import text from '~/text';
import { EmailSignupForm } from '~/view/components/common/DOM';

const props = defineProps({
  onClose: {
    type: Function,
    required: true,
  },
});
</script>
